"use client";

import dynamic from "next/dynamic";
import { ARTICLE_TOOLS, articleToolPath } from "@/lib/articles/articleTools";
import { SourcesVerifiees } from "@/components/Tools/SourcesVerifiees";
import styles from "./ArticleTool.module.css";

/**
 * Un outil du site posé en entier dans un article, à la place d'une capture.
 *
 * Même rendu que la page /embed (l'outil, puis une ligne de signature), mais
 * sans iframe : la page /embed n'est pas indexée et marque ses liens
 * utm_source=embed, ce qui compterait nos propres lecteurs comme des visiteurs
 * venus d'un site partenaire.
 *
 * Chaque outil est chargé à part : un article qui n'en porte aucun ne reçoit
 * rien, et celui qui en porte un ne reçoit que lui.
 */
const COMPOSANTS = {
    "combien-facturer": dynamic(() => import("@/components/Tools/DayRateCalculator")),
};

const TEXTES = {
    fr: {
        voir: "Ouvrir l'outil complet",
        indicatif: "Calcul indicatif, sans valeur juridique, d'après les barèmes officiels.",
    },
    en: {
        voir: "Open the full tool",
        indicatif: "Indicative calculation, with no legal force, based on official rates.",
    },
};

export default function ArticleTool({ cle, lang = "fr", aujourdhui, sources = {}, dates = {} }) {
    const Outil = COMPOSANTS[cle];
    if (!Outil || !ARTICLE_TOOLS[cle]) return null;
    const T = TEXTES[lang] || TEXTES.fr;

    return (
        // Les règles du texte de l'article ne s'appliquent pas à l'outil
        // (ArticleTool.module.css).
        <div className={`not-prose my-8 ${styles.cadre}`}>
            {/* Les sources viennent du serveur (lib/articles/articleToolSources.js) :
                le détail d'un montant les cite, comme sur la page de l'outil. */}
            <SourcesVerifiees sources={sources} dates={dates}>
                <Outil lang={lang} aujourdhui={aujourdhui} />
            </SourcesVerifiees>
            <p className="mb-0 mt-3 flex flex-wrap items-center justify-between gap-x-4 gap-y-1 px-1 text-xs text-gray-500">
                <span>{T.indicatif}</span>
                {/* Pas de couleur sur le lien lui-même : la règle globale
                    a:hover la repeindrait en rose. */}
                <a href={articleToolPath(cle, lang)} className="no-underline">
                    <span className="text-gray-600 hover:text-primary">{T.voir} →</span>
                </a>
            </p>
        </div>
    );
}
